import { useState } from "react";
import styles from "./ChatFooter.module.css";

const MAX_CHARACTERS = 300;

interface ChatFooterProps {
  onSend: (message: string) => void;
  disabled?: boolean;
  sendButtonImageUrl: string;
}

const ChatFooter = ({ onSend, disabled = false, sendButtonImageUrl }: ChatFooterProps) => {
  const [value, setValue] = useState("");
  const [charCount, setCharCount] = useState(0);

  const handleSend = () => {
    const trimmed = value.trim();
    if (!trimmed) return;
    onSend(trimmed);
    setValue("");
    setCharCount(0);
  };

  const handleKeyDown = (e: React.KeyboardEvent<HTMLTextAreaElement>) => {
    if (e.key === "Enter" && !e.shiftKey) {
      e.preventDefault();
      handleSend();
    }
  };

  return (
    <section className={styles.footer}>
      <textarea
        className={styles.input}
        value={value}
        onChange={(e) => {
          const newValue = e.target.value;
          if (newValue.length <= MAX_CHARACTERS) {
            setValue(newValue);
            setCharCount(newValue.length);
          }
        }}
        onKeyDown={handleKeyDown}
        placeholder="Skriv här..."
        disabled={disabled}
        aria-label="Meddelandefält"
      />
      <div className={styles.charCounter}>
        {charCount}/{MAX_CHARACTERS}
      </div>
      <button
        className={`${styles.sendButton} ${disabled ? styles.disabled : ""}`}
        onClick={handleSend}
        disabled={disabled}
        aria-label="Skicka meddelande"
      >
        <img
          src={sendButtonImageUrl}
          alt="Skicka meddelande"
          className={styles.sendIcon}
        />
      </button>
    </section>
  );
};

export default ChatFooter;
